import toast from 'react-hot-toast';

type ToastArgs = {
  title: string;
  description?: string | string[];
};

const BaseToast = ({ title, description }: ToastArgs) => (
  <div>
    <p style={{ fontWeight: 600, margin: 0 }}>{title}</p>
    {Array.isArray(description) && description.length > 1 ? (
      <ul>
        {description.map((item, index) => (
          <li key={index}>
            <p style={{ fontSize: 13, marginTop: 2 }}>{item}</p>
          </li>
        ))}
      </ul>
    ) : description ? (
      <p style={{ fontSize: 13, marginTop: 2 }}>{description}</p>
    ) : null}
  </div>
);

export const showSuccessToast = (title: string, description?: string | string[]) =>
  toast.success(<BaseToast title={title} description={description} />, {
    icon: null,
  });

export const showErrorToast = (title: string, description?: string | string[]) =>
  toast.error(<BaseToast title={title} description={description} />, {
    icon: null,
  });
